import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const insightsPortalAccessControl: DomainAccessControlConfig = {
  permissions: Permission.Performance,
}

export const insightsPortalRrcCodeDimensionAccessControl: DomainAccessControlConfig = [
  {
    minICPlatformVersion: ICPlatformVersion.r2025_10_0,
  },
]
